import React from 'react';
import '../../css/intro.css'
import '../../css/maze.css'
import '../../css/font-googleapis.css';
import '../../css/responsive.css';
import '../../css/footer.css';
import HomePage from './section/home_page';
const Home=()=>{ 
    return(
        <>
       <HomePage/>
        </>
    );
}
export default Home;